import { MediaText } from 'editor/src/store/design/types';

import limitPrecision from 'editor/src/util/limitPrecision';

export default function getReflowTextStyleKey(element: MediaText): string {
  const { extra } = element;
  return JSON.stringify(
    [
      extra.fontFamily,
      extra.fontSize,
      extra.lineHeight,
      extra.letterSpacing,
      extra.textAlign,
      extra.wrapping,
      extra.lockBoxSize,
      extra.flexibleWidth,
      extra.customFontLayout,
      extra.curve,
      element.sx ?? 1,
      element.sy ?? 1,
    ].map((value) => (typeof value === 'number' ? limitPrecision(value) : value)),
  );
}
